import AccidentsIncidentsScreen from "app/screens/pendingSignOffs/AccidentsIncidentsScreen";

export default function AccidentsIncidentsPage() {
  return <AccidentsIncidentsScreen />;
}
